import React, {Component} from 'react';
import DocumentTitle from 'react-document-title';

class Calendar extends Component {

    constructor(props) {
        super(props);

        this.state = {
        }

        this.props.includeNav();
    }

    render() {

        return (
            <DocumentTitle
                title={'BCS Documentation - Calendar'}>
                <section className="page" data-component="calendar">
                    <div className="row">
                        <div className="col-xs-12 col-gutter-lr border-bottom">
                            <h1>Calendar</h1>
                        </div>
                        <div className="bcs-calendar margin-t-6">
                            <ul className="calendar-days">
                                <li>Sun</li>
                                <li>Mon</li>
                                <li>Tue</li>
                                <li>Wed</li>
                                <li>Thu</li>
                                <li>Fri</li>
                                <li>Sat</li>
                            </ul>
                            <ul className="calendar-grid">
                                <li className="hide-xs show-md">
                                <time className="calendar-date">
                                    <strong>1</strong>
                                    <span>Sun</span>
                                </time>
                                <ul className="calendar-event-list">

                                </ul>
                                </li>
                                <li>
                                <time className="calendar-date">
                                    <strong>2</strong>
                                    <span>Mon</span>
                                </time>
                                <ul className="calendar-event-list">
                                    <li className="calendar-event-session">
                                    <a href="/">Session: JS Testing Lecture</a>
                                    </li>
                                    <li className="calendar-event-orientation">
                                    <a href="/">Meet and greet</a>
                                    </li>
                                </ul>
                                </li>
                                <li className="hide-xs show-md">
                                <time className="calendar-date">
                                    <strong>3</strong>
                                    <span>Tue</span>
                                </time>
                                <ul className="calendar-event-list">

                                </ul>
                                </li>
                                <li>
                                <time className="calendar-date">
                                    <strong>4</strong>
                                    <span>Wed</span>
                                </time>
                                <ul className="calendar-event-list">
                                  <li className="calendar-event-assigned">
                                  <a href="/">Assigned: Resume Rough Draft</a>
                                  </li>
                                  <li className="calendar-event-due">
                                  <a href="/">Due: jQuery Hangman</a>
                                  </li>
                                </ul>
                                </li>
                                <li className="hide-xs show-md">
                                <time className="calendar-date">
                                    <strong>5</strong>
                                    <span>Thu</span>
                                </time>
                                <ul className="calendar-event-list">

                                </ul>
                                </li>
                                <li className="hide-xs show-md">
                                <time className="calendar-date">
                                    <strong>6</strong>
                                    <span>Fri</span>
                                </time>
                                <ul className="calendar-event-list">

                                </ul>
                                </li>
                                <li className="hide-xs show-md">
                                <time className="calendar-date">
                                    <strong>7</strong>
                                    <span>Sat</span>
                                </time>
                                <ul className="calendar-event-list">

                                </ul>
                                </li>
                                <li className="hide-xs show-md">
                                <time className="calendar-date">
                                    <strong>8</strong>
                                    <span>Sun</span>
                                </time>
                                <ul className="calendar-event-list">
                                </ul>
                                </li>
                                <li className="hide-xs show-md">
                                <time className="calendar-date">
                                    <strong>9</strong>
                                    <span>Mon</span>
                                </time>
                                <ul className="calendar-event-list">

                                </ul>
                                </li>
                                <li className="hide-xs show-md">
                                <time className="calendar-date">
                                    <strong>10</strong>
                                    <span>Tue</span>
                                </time>
                                <ul className="calendar-event-list">

                                </ul>
                                </li>
                                <li className="hide-xs show-md">
                                <time className="calendar-date">
                                    <strong>11</strong>
                                    <span>Wed</span>
                                </time>
                                <ul className="calendar-event-list">

                                </ul>
                                </li>
                                <li className="hide-xs show-md">
                                <time className="calendar-date">
                                    <strong>12</strong>
                                    <span>Thu</span>
                                </time>
                                <ul className="calendar-event-list">

                                </ul>
                                </li>
                                <li>
                                <time className="calendar-date">
                                    <strong>13</strong>
                                    <span>Fri</span>
                                </time>
                                <ul className="calendar-event-list">
                                    <li className="calendar-event-assigned">
                                    <a href="/">Assigned: Resume Rough Draft</a>
                                    </li>
                                </ul>
                                </li>
                                <li className="hide-xs show-md">
                                <time className="calendar-date">
                                    <strong>14</strong>
                                    <span>Sat</span>
                                </time>
                                <ul className="calendar-event-list">

                                </ul>
                                </li>
                                <li className="hide-xs show-md">
                                <time className="calendar-date">
                                    <strong>15</strong>
                                    <span>Sun</span>
                                </time>
                                <ul className="calendar-event-list">

                                </ul>
                                </li>
                                <li className="hide-xs show-md">
                                <time className="calendar-date">
                                    <strong>16</strong>
                                    <span>Mon</span>
                                </time>
                                <ul className="calendar-event-list">
                                </ul>
                                </li>
                                <li>
                                <time className="calendar-date">
                                    <strong>17</strong>
                                    <span>Tue</span>
                                </time>
                                <ul className="calendar-event-list">
                                    <li className="calendar-event-session">
                                    <a href="/">Session: JS Testing Lecture</a>
                                    </li>
                                </ul>
                                </li>
                                <li className="hide-xs show-md">
                                <time className="calendar-date">
                                    <strong>18</strong>
                                    <span>Wed</span>
                                </time>
                                <ul className="calendar-event-list">

                                </ul>
                                </li>
                                <li>
                                <time className="calendar-date">
                                    <strong>19</strong>
                                    <span>Thu</span>
                                </time>
                                <ul className="calendar-event-list">
                                    <li className="calendar-event-assigned">
                                    <a href="/">Assigned: Resume Rough Draft</a>
                                    </li>
                                    <li className="calendar-event-due">
                                    <a href="/">Due: jQuery Hangman</a>
                                    </li>
                                </ul>
                                </li>
                                <li className="hide-xs show-md">
                                <time className="calendar-date">
                                    <strong>20</strong>
                                    <span>Fri</span>
                                </time>
                                <ul className="calendar-event-list">

                                </ul>
                                </li>
                                <li className="hide-xs show-md">
                                <time className="calendar-date">
                                    <strong>21</strong>
                                    <span>Sat</span>
                                </time>
                                <ul className="calendar-event-list">

                                </ul>
                                </li>
                                <li className="hide-xs show-md">
                                <time className="calendar-date">
                                    <strong>22</strong>
                                    <span>Sun</span>
                                </time>
                                <ul className="calendar-event-list">

                                </ul>
                                </li>
                                <li>
                                <time className="calendar-date">
                                    <strong>23</strong>
                                    <span>Mon</span>
                                </time>
                                <ul className="calendar-event-list">
                                    <li className="calendar-event-due">
                                    <a href="/">Due: jQuery Hangman</a>
                                    </li>
                                    <li className="calendar-event-session">
                                    <a href="/">Session: JS Testing Lecture</a>
                                    </li>
                                </ul>
                                </li>
                                <li className="hide-xs show-md">
                                <time className="calendar-date">
                                    <strong>24</strong>
                                    <span>Tue</span>
                                </time>
                                <ul className="calendar-event-list">

                                </ul>
                                </li>
                                <li className="hide-xs show-md">
                                <time className="calendar-date">
                                    <strong>25</strong>
                                    <span>Wed</span>
                                </time>
                                <ul className="calendar-event-list">

                                </ul>
                                </li>
                                <li className="show-md">
                                <time className="calendar-date">
                                    <strong>26</strong>
                                    <span>Thu</span>
                                </time>
                                <ul className="calendar-event-list">
                                  <li className="calendar-event-orientation">
                                  <a href="/">Introduce new process</a>
                                  </li>
                                </ul>
                                </li>
                                <li className="hide-xs show-md">
                                <time className="calendar-date">
                                    <strong>27</strong>
                                    <span>Fri</span>
                                </time>
                                <ul className="calendar-event-list">

                                </ul>
                                </li>
                                <li className="hide-xs show-md">
                                <time className="calendar-date">
                                    <strong>28</strong>
                                    <span>Sat</span>
                                </time>
                                <ul className="calendar-event-list">

                                </ul>
                                </li>
                                <li className="hide-xs show-md">
                                <time className="calendar-date">
                                    <strong>29</strong>
                                    <span>Sun</span>
                                </time>
                                <ul className="calendar-event-list">

                                </ul>
                                </li>
                                <li className="hide-xs show-md">
                                <time className="calendar-date">
                                    <strong>30</strong>
                                    <span>Mon</span>
                                </time>
                                <ul className="calendar-event-list">

                                </ul>
                                </li>
                                <li className="hide-xs show-md">
                                <time className="calendar-date">
                                    <strong>31</strong>
                                    <span>Tue</span>
                                </time>
                                <ul className="calendar-event-list">

                                </ul>
                                </li>
                                <li className="hide-xs show-md"></li>
                                <li className="hide-xs show-md"></li>
                                <li className="hide-xs show-md"></li>
                                <li className="hide-xs show-md"></li>
                            </ul>
                        </div>
                    </div>
                </section>
            </DocumentTitle>
        )
    }
}

export default Calendar;



// WEBPACK FOOTER //
// ./src/pages/Calendar/index.js